import { LembreteProfissionalIdentificadorEnum } from 'graphql/types.generated'
import { ReactNode, RefObject } from 'react'

export enum TourPlacementEnum {
  AUTO = 'AUTO',
  CENTER = 'CENTER',
  TOP = 'TOP',
  BOTTOM = 'BOTTOM',
  LEFT = 'LEFT',
  RIGHT = 'RIGHT',
  TOP_START = 'TOP_START',
  TOP_END = 'TOP_END',
  BOTTOM_START = 'BOTTOM_START',
  BOTTOM_END = 'BOTTOM_END',
  LEFT_START = 'LEFT_START',
  LEFT_END = 'LEFT_END',
  RIGHT_START = 'RIGHT_START',
  RIGHT_END = 'RIGHT_END',
}

export const tourPlacementRecord: Record<
  TourPlacementEnum,
  | 'auto'
  | 'center'
  | 'top'
  | 'bottom'
  | 'left'
  | 'right'
  | 'top-start'
  | 'top-end'
  | 'bottom-start'
  | 'bottom-end'
  | 'left-start'
  | 'left-end'
  | 'right-start'
  | 'right-end'
> = {
  [TourPlacementEnum.AUTO]: 'auto',
  [TourPlacementEnum.CENTER]: 'center',
  [TourPlacementEnum.TOP]: 'top',
  [TourPlacementEnum.BOTTOM]: 'bottom',
  [TourPlacementEnum.LEFT]: 'left',
  [TourPlacementEnum.RIGHT]: 'right',
  [TourPlacementEnum.TOP_START]: 'top-start',
  [TourPlacementEnum.TOP_END]: 'top-end',
  [TourPlacementEnum.BOTTOM_START]: 'bottom-start',
  [TourPlacementEnum.BOTTOM_END]: 'bottom-end',
  [TourPlacementEnum.LEFT_START]: 'left-start',
  [TourPlacementEnum.LEFT_END]: 'left-end',
  [TourPlacementEnum.RIGHT_START]: 'right-start',
  [TourPlacementEnum.RIGHT_END]: 'right-end',
}

export interface TourStep {
  target: string | HTMLElement
  content: ReactNode
  title?: ReactNode
  placement?: TourPlacementEnum
  spotlightPadding?: number
}

export interface TourDefinition {
  tourId: string
  steps: TourStep[]
}

export interface AutoTourDefinition {
  tourId: LembreteProfissionalIdentificadorEnum
  lembreteId: string
  steps: TourStep[]
}

export type ManagedTour = (TourDefinition & { mode: 'manual' }) | (AutoTourDefinition & { mode: 'auto' })

export type TourState = {
  activeTour: ManagedTour | null
  queue: ManagedTour[]
  runKey: number
}

export type TourAction =
  | {
      type: 'START_TOUR'
      tour: ManagedTour
    }
  | {
      type: 'FINISH_TOUR'
      runKey: number
    }
  | {
      type: 'STOP_TOUR'
    }

export interface TourControllerContextData {
  startTour: (tour: TourDefinition) => void
  startAutoTour: (tour: AutoTourDefinition) => void
  stopTour: () => void
}

export interface TourTooltipContextData {
  tooltipRef: RefObject<HTMLElement | null>
  setTooltipNode: (node: HTMLElement | null) => void
}
